import { render, staticRenderFns } from "./payment-policies.vue?vue&type=template&id=0ba20f41&scoped=true"
import script from "./payment-policies.vue?vue&type=script&lang=ts"
export * from "./payment-policies.vue?vue&type=script&lang=ts"
import style0 from "./payment-policies.vue?vue&type=style&index=0&id=0ba20f41&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba20f41",
  null
  
)

export default component.exports